// Phase 4b: Convert-to-Proposal confirmation dialog. Sibling of
// ConvertToPreAwardDialog — a one-shot promotion, no form fields. The backend
// spawns a Proposal project (type=proposal) linked back to the source capture,
// marks the capture converted, and returns the proposal id; we route the user
// to the proposal workspace on success.
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraOverlayDialog } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useConvertCaptureToProposal } from '../../pages/Capture/hooks';
export function ConvertToProposalDialog({ open, onOpenChange, captureProjectId }) {
    const navigate = useNavigate();
    const convert = useConvertCaptureToProposal();
    const handleConfirm = async ()=>{
        try {
            const summary = await convert.mutateAsync({
                captureProjectId
            });
            toast.success('Proposal workspace created.');
            onOpenChange(false);
            navigate(`/proposal/${summary.proposalProjectId}`);
        } catch (err) {
            toast.error(err instanceof Error ? err.message : 'Failed to convert capture to proposal');
        }
    };
    return /*#__PURE__*/ _jsx(SpecraOverlayDialog, {
        open: open,
        onOpenChange: onOpenChange,
        title: "Convert to Proposal",
        description: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                "Spawn a Proposal workspace for this pursuit and mark this capture",
                ' ',
                /*#__PURE__*/ _jsx("strong", {
                    children: "converted"
                }),
                ". The capture's RFIs, interactions, workstreams, and graph stay intact and remain linked to the new proposal as its source. This capture is not deleted."
            ]
        }),
        testId: Testids.capture.convertDialog,
        className: "sm:max-w-[500px]",
        // Header + footer only: collapse the shell's body slot so no blank
        // padded strip renders between them.
        scrollBody: false,
        focusableBody: false,
        bodyProps: {
            className: 'hidden'
        },
        footerProps: {
            cancelLabel: 'Cancel',
            onCancel: ()=>onOpenChange(false),
            cancelProps: {
                disabled: convert.isPending
            },
            confirmLabel: convert.isPending ? 'Converting…' : 'Convert to Proposal',
            onConfirm: handleConfirm,
            confirmProps: {
                disabled: convert.isPending,
                'data-testid': Testids.capture.convertConfirm
            }
        },
        children: null
    });
}
